export const capitalize = (text: string = "") => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const trimUserToken = (token: string) => {
  return "... " + token.slice(-10);
};
